<template lang="pug">
  .cybersmart-footer
    div.copyright-block
      p(v-html="copyrightText").has-text-centered.has-text-weight-normal.copyright
      a(href="/legal/ISPA/ISPA_Code_of_Conduct",v-if="showBanners || showBlackFriday")
        img.ispa-icon(alt="ISPA logo", src="/img/ispa.png")
      a(href="https://www.icode.org.za/",v-if="showBanners")
        img.ispa-icon(alt="ICODE logo", src="/img/icode.png")
    div.shop-logo(v-if="showBanners")
      a(href="https://shop.cybersmart.co.za/shop", target="_blank")
        img.shop-logo__img-top(src="/img/home_graphic_black-friday.svg" alt="Cybersmart Shop")
        img.shop-logo__img-top__mobile(src="/img/mobile-shop-now-graphic.svg" alt="Cybersmart Shop")
        img.shop-logo__img-bottom(alt="Cybermsart Shop", src="/img/mini-ups.png")
    div.black-friday-logo(v-if="showBlackFriday")
      a(href="https://promo.cybersmart.co.za", target="_blank")
        img.black-friday-logo__img-top(src="/img/home_graphic_desktop.jpg" alt="Cybersmart Shop")
        img.black-friday-logo__img-top__mobile(src="/img//home_graphic_mobile.jpg" alt="Cybersmart Shop")
    div.logo
      img.market-icon(alt="Top Ranked ISP in SOUTH AFRICA", :src="marketingLogoURL")
</template>

<script>
  import moment from 'moment'
  import brand from '../brand'

  export default {
    data: () => ({
      date: moment().format('YYYY'),
    }),
    computed: {
      copyrightText() {
        const copyrights = {
          "cybersmart": "© " + this.date + " CYBERSMART (PTY) LTD ALL RIGHTS RESERVED",
          "ftta": "© Copyright " + this.date + " Fibre to the Apartment (Pty) Ltd All Rights Reserved",
          "gigalight" : "Copyright © " + this.date + " Gigalight",
        };

      return copyrights[brand.getBrand()];
      },
      marketingLogoURL() {
        const urls = {
          "cybersmart": "/img/marketing.svg",
          "ftta"      : "/img/ftta-foot-logo.svg",
          "gigalight" : "/img/bg-boy-Blue.png",
        };

        return urls[brand.getBrand()];
      },
      showBanners() {
        const show = {
          "cybersmart": false,
          "ftta"      : false,
          "gigalight" : false,
        };

        return show[brand.getBrand()];
      },
      showBlackFriday() {
        const show = {
          "cybersmart": true,
          "ftta"      : false,
          "gigalight" : false,
        };

        return show[brand.getBrand()];
      }
    }
  }
</script>
<style lang="scss">
  @import "~bulma/sass/utilities/mixins";
  .row {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    justify-content: space-between;
  }

  .cybersmart-footer {
    display: flex;
    justify-content: space-between;
    padding: 2rem 3rem;
    align-items: center;

    &.blur {
      filter: blur(3px);
    }
    .copyright {
      flex: 1;
      font-size: 0.6rem;
      letter-spacing: 2px;
      @include mobile() {
        order: 1;
      }
    }

    .market-icon {
      width: 0;
      height: 75%;

      @include from($desktop) {
        width: 164px;
      }
    }

    .ispa-icon {
      height: 27px;

      @include from($desktop) {
      }
    }
    .shop-logo {
      height: 130px;
      & a {
        display: contents;
      }
      & img {
        display: grid;
        position: relative;
      }
      &__img-top {
        width: 227px;
        //top: -100px;
        cursor: pointer;
        @include mobile() {
          //width: 170px;
          display: none!important;
        }
        &__mobile {
          width: 227px;
          @include from($desktop){
            display: none!important;
          }
          @include from($tablet) {
            display: none!important;
          }
        }
      }
      &__img-bottom {
        background: transparent;
        width: 140px;
        top: -92px;
        left: 25px;
        @include mobile() {
          width: 108px;
          top: -72px;
          left: 39px;
        }
      }
      @include from($tablet) {
        margin-right: 100px;
      }
      @include from($desktop) {
        margin-right: 220px;
      }
      @include mobile() {
        order: 1;
        margin-bottom: 20px;
        margin-right: unset;
      }
    }
    .black-friday-logo {
      height: 165px;
      &__img-top {
        margin-right: 90px;
        @include mobile() {
          //width: 170px;
          display: none!important;
        }
        &__mobile {
          @include from($desktop){
            display: none!important;
          }
          @include from($tablet) {
            display: none!important;
          }
        }
      }
      @include mobile() {
        height: unset;
      }
    }
    .copyright-block {
      @include mobile() {
        order: 2;
      }
    }
    @include mobile{
      display: flex;
      flex-flow: column;
    }
  }
</style>
